import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Empty } from '@/shared/ui/empty/empty';
import { EmptyContent } from '@/shared/ui/empty/empty-content';
import { EmptyDescription } from '@/shared/ui/empty/empty-description';
import { EmptyHeader } from '@/shared/ui/empty/empty-header';
import { EmptyMedia } from '@/shared/ui/empty/empty-media';
import { EmptyTitle } from '@/shared/ui/empty/empty-title';

type EmptyStateProps = {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
};

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Empty className="border border-dashed bg-card/50">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {action && <EmptyContent>{action}</EmptyContent>}
    </Empty>
  );
}
